/** Foundation · Copy — scelta dell'origine; ogni origine può richiedere un parametro (mese, soggetto…). */
import React from "react";

export function CopySourcePicker({ sources, value, onChange }) {
  return (
    <div className="space-y-1.5" data-testid="copy-from-sources">
      <div className="text-[10px] font-semibold uppercase tracking-wider text-suite-neutral-500">Copia da</div>
      {sources.map((s) => {
        const active = value.id === s.id;
        return (
          <div key={s.id} className={`rounded-md border px-3 py-2 transition-colors ${active ? "border-suite-primary bg-suite-primary-light/40" : "border-suite-neutral-200 hover:bg-suite-neutral-50"} ${s.disabled ? "opacity-50" : ""}`}>
            <button type="button" disabled={s.disabled} className="w-full text-left" onClick={() => onChange({ id: s.id, param: s.choices?.[0]?.value })} data-testid={`copy-from-source-${s.id}`}>
              <div className="text-sm font-medium text-suite-neutral-900">{s.label}</div>
              {s.description && <div className="text-[11px] text-suite-neutral-500">{s.description}</div>}
            </button>
            {active && s.choices && (
              <select value={value.param || ""} onChange={(e) => onChange({ id: s.id, param: e.target.value })}
                className="mt-2 h-8 w-full rounded-md border border-input bg-white px-2 text-xs" data-testid={`copy-from-source-${s.id}-param`}>
                {!s.choices.length && <option value="">Nessuna origine disponibile</option>}
                {s.choices.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
              </select>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default CopySourcePicker;
